import { render, staticRenderFns } from "./PaymentMethods.vue?vue&type=template&id=16218662&scoped=true&lang=pug&"
import script from "./PaymentMethods.vue?vue&type=script&lang=js&"
export * from "./PaymentMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16218662",
  null
  
)

export default component.exports